import React, { useContext, useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Events from './Events';
import Gifts from './Gifts';
import Lists from './Lists';
import Notes from './Notes';
import LeadOpps from './LeadOpps';
import LeadOppsLoan from './LeadOpps/loan';
import Loans from './Loans';
import LoansV2 from './Loans/v2';
import Offers from './Offers';
import Referrals from './Referrals';
import IntroducedTo from './IntroducedTo';
import ReferredOut from './ReferredOut';
import Reviews from './Reviews';
import Tasks from './Tasks';
import TaskAssocs from './TaskAssocs';
import GiftRecipients from './GiftRecipients';
import Borrowers from './Borrowers';
import LeadOppRelationships from './LeadOppRelationships';
import NoteAssocs from './NoteAssocs';
import { ObjModal } from '../../../contexts';
import ReviewAssocs from './ReviewAssocs';
import Files from './Files';
import Business from './Business';
import AutoControls from './AutoControls';
import ObjFields from './ObjFields';


const Sidebar = ( { layout } ) => {
    const [ view, setView ] = useState( [] );
    const { obj } = useContext( ObjModal );

    useEffect( () => {
        if ( layout ) {
            if ( layout.key && layout[obj.details[layout.key]] ) {
                setView( layout[obj.details[layout.key]] );
            } else {
                setView( layout.default );
            }
        }
    }, [ layout, obj.details ] );

    const options = {
        events: Events,
        gifts: Gifts,
        giftrecipients: GiftRecipients,
        lists: Lists,
        leadopps: LeadOpps,
        leadoppsloan: LeadOppsLoan,
        loans: Loans,
        loansv2: LoansV2,
        notes: Notes,
        offers: Offers,
        referrals: Referrals,
        introducedto: IntroducedTo,
        referredout: ReferredOut,
        reviews: Reviews,
        reviewassocs: ReviewAssocs,
        tasks: Tasks,
        taskassocs: TaskAssocs,
        borrowers: Borrowers,
        leadopprelationships: LeadOppRelationships,
        noteassocs: NoteAssocs,
        files: Files,
        business: Business,
        autocontrols: AutoControls
    };

    return (
        <Container fluid className='p-0'>
            {
                view?.map( ( l, idx ) => {
                    if ( typeof( l ) === 'string' ) {
                        const C = options[l];

                        return (
                            ( C ) ? (
                                <Row className='tf-section-container p-0' style={ ( idx === 0 ) ? { marginTop: '0' } : { marginTop: '10px' } } key={idx}>
                                    <Col className='p-0'>
                                        <C />
                                    </Col>
                                </Row>
                            ) : (
                                null
                            )
                        );
                    } else if ( typeof( l ) === 'object' ) {
                        return (
                            <Row className='tf-section-container p-0' style={ ( idx === 0 ) ? { marginTop: '0' } : { marginTop: '10px' } } key={idx}>
                                <Col className='p-0'>
                                    <ObjFields key={idx} title={l.title} body={l.body} />
                                </Col>
                            </Row>
                        )
                    }
                    return null;
                } )
            }
        </Container>
    )
}

export default Sidebar;